'use strict';

import { view } from '@/functions';

const prefix = '/transactions';
export default [
	{
		path: prefix,
		name: 'transactions',
		meta: {
			title: 'Transactions',
			scopes: ['read_transactions', 'write_transactions']
		},
		component: () => view('transactions/index')
	},

	{
		path: `${prefix}/info`,
		name: 'transactions-info',
		meta: {
			title: 'Transactions',
			scopes: ['read_transactions', 'write_transactions'],
			workspace: true,
		},
		component: () => view('transactions/infov2')
	},
	{
		path: `${prefix}/v1`,
		name: 'transactions-info-v1',
		meta: {
			title: 'Transactions',
			scopes: ['read_transactions', 'write_transactions'],
		},
		component: () => view('transactions/info')
	},
]; 